import _ from "lodash";
import { useConfig } from "src/hooks/config";

interface IProps {
    base?: number;
};

const MarketBase = ({ base }: IProps) => {
    const config = useConfig();

    if (_.isNil(base)) return null;

    return <>{config.drawSignWithMarketBase && base >= 0 ? '+' : ''}{base}</>;
};

export default MarketBase;